<template>
	<div class="pro_cn">
		<div class="profile_pc" v-if="!isPhone">
			<div class="pro_con">
				<div class="pro_box1">
					<p class="pb1_tit">集团介绍</p>
					<div data-aos="fade-up" v-html="jcinfo.content"></div>
				</div>
				<div class="pro_box2">
					<p class="pb1_tit2">子公司</p>
					<ul class="pb2_ul">
						<li data-aos="fade-up" class="pb2_li" v-for="(item, index) in subsidiary" :key="index">
							<div class="pb2_li_con">
								<div class="pb2_li_con_b1">
									<img :src="staticImg + item.image" />
								</div>
								<div class="pb2_li_con_b2">
									<p class="cb_p1">{{ item.title }}</p>
									<p class="cb_p2">{{ item.description }}</p>
								</div>
							</div>
						</li>
					</ul>
				</div>
				<record></record>
			</div>
		</div>
		<div class="profile_phone" v-if="isPhone">
			<Header2 :searchShow="false" pageTitle="关于我们"></Header2>
			<div class="zr_tab_box flex2">
				<div @click="zrTabChange(index)" v-for="(item, index) in tabList" :key="index" class="zr_tab_item"
					:class="pcrut == index ? 'ph_act1' : ''">
					{{ item }}
				</div>
			</div>
			<div class="jtjs_phone" v-if="pcrut == 0">
				<div class="pro_con">
					<div class="pro_box1" data-aos="fade-up">
						<p class="pb1_tit">集团介绍</p>
						<div class="jc_pare" :class="iszk ? 'pro_act1' : ''" v-html="jcinfo.content"></div>
						<p class="zhankai" @click="handOpen">
							{{ iszk ? "点击收起" : "点击展开" }} >
						</p>
					</div>
					<div class="pro_box2">
						<p class="pb1_tit2">子公司</p>
						<ul class="pb2_ul">
							<li data-aos="fade-up" class="pb2_li" v-for="(item, index) in subsidiary" :key="index">
								<div class="pb2_li_con">
									<div class="pb2_li_con_b1">
										<img :src="staticImg + item.image" />
									</div>
									<div class="pb2_li_con_b2">
										<p class="cb_p1">{{ item.title }}</p>
										<p class="cb_p2">
											{{ item.description }}
										</p>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="qyry_phone" v-if="pcrut == 1">
				<div class="nf_list">
					<div class="nf_item" @click="selYear(index)" :class="yearAct==index?'pact2':''" v-for="(item, index) in qyryList"
						:key="index">{{item.year}}</div>
				</div>
				<ul class="ry_ul">
					<li class="ry_li" data-aos="fade-up" v-for="(item, index) in qyryList[yearAct].banner" :key="index">
						<div class="ry_li_img">
							<img :src="staticImg + item.image" />
						</div>
						<p class="ry_li_tit">{{ item.title }}</p>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			jcinfo: {},
			subsidiary: [],
			staticImg: this.$staticImg + "/",
			isPhone: this.$isMobile,
			pcrut: 0,
			tabList: ["公司简介", "企业荣誉"],
			iszk: false,
			qyryList: [],
			yearAct: 0,
		}
	},
	created() {
		this.basicInfo();
		this.zcompany();
		this.honor();
	},
	methods: {
		// 基础信息
		async basicInfo() {
			const res = await this.$api.basicInfo();
			if (res.code == 1) {
				this.jcinfo = res.data;
			}
		},
		// 子公司
		async zcompany() {
			const res = await this.$api.zcompany();
			if (res.code == 1) {
				this.subsidiary = res.data;
			}
		},
		// 企业荣誉
		async honor() {
			const res = await this.$api.honor();
			if (res.code == 1) {
				this.qyryList = res.data;
			}
		},
		zrTabChange(index) {
			this.pcrut = index;
			window.scrollTo({
				top: 0,
			});
		},
		handOpen() {
			this.iszk = !this.iszk;
		},
		selYear(e) {
			this.yearAct = e;
		}
	},
}
</script>

<style lang="scss">
.pro_act1 {
	height: auto !important;
}
.pact2 {
	font-weight: bold;
}
.pro_cn {
    @font-face {
        font-family: 'SourceHanSans';
        src: url('../../font/SourceHanSansCN-Regular.otf');
    }
    font-family: 'SourceHanSans';
	.profile_pc {
		margin-top: 76px;
		width: 100%;
		padding: 68px 20px 80px 0;
		background-image: url("../../images/bgimg3.png");
		box-sizing: border-box;
		.pro_con {
			max-width: 1278px;
			min-width: 950px;
			margin: 0 auto;
			.pro_box1 {
				padding-bottom: 64px;
				.pb1_tit {
					text-align: center;
					color: #c0494b;
					font-size: 36px;
					margin-bottom: 40px;
				}
                div{
                    img{
                        max-width: 100% !important;
                    }
                }
			}
			.pro_box2 {
				.pb1_tit2 {
					margin-bottom: 70px;
					text-align: center;
					color: #c0494b;
					font-size: 36px;
				}
				.pb2_ul {
					margin: 0 -25px;
					display: flex;
					flex-wrap: wrap;
					.pb2_li {
						width: 50%;
						padding: 0 28px;
						margin-bottom: 40px;
						box-sizing: border-box;
						.pb2_li_con {
							background-color: #fff;
							.pb2_li_con_b1 {
								overflow: hidden;
								img {
									width: 100%;
									transition: transform 0.5s ease;
									&:hover {
										transform: scale(1.1);
									}
								}
							}
							.pb2_li_con_b2 {
								padding: 30px 25px;
								p {
									text-align: left;
								}
								.cb_p1 {
									color: #000;
									font-size: 24px;
									overflow: hidden;
									text-overflow: ellipsis;
									white-space: nowrap;
								}
								.cb_p2 {
									color: #666;
									font-size: 14px;
									line-height: 1.8;
									margin-top: 18px;
									height: 125px;
									overflow: hidden;
								}
							}
						}
					}
				}
			}
		}
	}
	.profile_phone {
		background-image: url("../../images/bgimg3.png");
		padding: 1.5rem 0 2rem 0;
		min-height: 90vh;
		.jtjs_phone {
			padding: 0.48rem;
			padding-top: 1.17rem;
			.pro_con {
				.pro_box1 {
					.pb1_tit {
						text-align: center;
						color: #c0494b;
						font-size: 19px;
						font-weight: 700;
						margin-bottom: 0.32rem;
					}
					.jc_pare {
						height: 7.6rem;
						overflow: hidden;
						img {
							width: 100% !important;
						}
					}
					.zhankai {
						text-align: center;
						color: #c00;
						font-size: 15px;
						margin-top: 0.2rem;
					}
				}
				.pro_box2 {
					padding-top: 0.67rem;
					.pb1_tit2 {
						text-align: center;
						color: #c0494b;
						font-size: 19px;
						font-weight: 700;
						margin-bottom: 0.32rem;
					}
					.pb2_ul {
						.pb2_li {
							margin-bottom: 0.53rem;
							.pb2_li_con {
								.pb2_li_con_b1 {
									overflow: hidden;
									img {
										width: 100%;
									}
								}
								.pb2_li_con_b2 {
									background-color: #fff;
									padding: 0.43rem;
									p {
										text-align: left;
									}
									.cb_p1 {
										color: #333;
										font-size: 17px;
										margin-bottom: 0.267rem;
									}
									.cb_p2 {
										color: #666;
										font-size: 13px;
										line-height: 1.8;
									}
								}
							}
						}
					}
				}
			}
		}
		.qyry_phone {
			padding: 0.67rem 0.53rem;
			padding-top: 1.3rem;
			.nf_list {
				width: 100%;
				overflow-x: auto;
				white-space: nowrap;
				display: inline-flex;
				background-color: #eee;
				.nf_item {
					display: inline-block;
					margin-right: 15px;
					font-size: 18px;
					padding: 5px 0;
				}
			}
			.ry_ul {
				margin-top: 10px;
				.ry_li {
					margin-bottom: 0.53rem;
					.ry_li_img {
						text-align: center;
						background: url("../../images/about//bmg2.png") no-repeat 50%;
						background-size: cover;
						padding: 0.4rem 0.267rem;
						height: 5.067rem;
						img {
							max-height: 100%;
							max-width: 100%;
						}
					}
					.ry_li_tit {
						text-align: center;
						color: #333;
						font-size: 17px;
						padding: 0.4rem 0.27rem;
						background-color: #fff;
					}
				}
			}
		}
	}
}
</style>